import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {NotificationComponent} from './notification.component';

const routes = [
    {
        path: '',
        component: NotificationComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class NotificationRoutingModule {
}
